import styled from "styled-components";
import Card from "@mui/material/Card";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { Subtitle } from "./HXDesktopPage.styles";
import { FlexColumn, FlexColumnDiv, FlexRow, FlexRowDiv } from "./common.styles";
import { HXMenuButton } from "./HXMenuButton";
import Delete from "@mui/icons-material/Delete";
import { HXTextField } from "./AccountSettingsProfileView.styles";
import Typography from "@mui/material/Typography";
import { HXMobilePageWithFixedHeaderAndFooterContainer, HXMobilePageWithFixedHeaderAndFooterContent } from "./HXMobilePage.styles";
import { fontWeights } from "healthex-common/weights";
export const AdminDataPolicyParent = styled(FlexColumnDiv) `
    align-items: flex-start;
    gap: 20px;
    flex: 1 0 0;
    align-self: stretch;

    & a {
        color: ${colors.navy_main};
    }
`;
export const AdminDataPolicyContentContainer = styled(FlexColumn) `
    flex: 1 0 0;
    gap: 16px;
`;
export const AdminDataPolicyTitle = styled.div `
    color: ${colors.black_main};
    font-size: ${fontSizes.SUPER};
    font-weight: ${fontWeights.SEMI_BOLD};
    padding: 24px 0;
`;
export const AdminDataPolicySearchContainer = styled(FlexColumn) `
    padding: 24px;
    gap: 16px;

    border-radius: 4px;
    border: 1px solid ${colors.sunset_main};
    background: ${colors.sunset_8};
`;
export const AdminDataPolicySubtitle = styled(Subtitle) `
    font-size: ${fontSizes.MEDIUM};
`;
export const AdminDataPolicyRecentContainer = styled(FlexColumn) `
    padding: 24px 0;
    align-items: stretch;
    gap: 16px;
`;
export const TabContainer = styled(FlexColumn) `
    align-items: stretch;
    gap: 16px;
`;
export const SummaryContainer = styled(FlexColumn) `
    gap: 16px;
`;
export const SummaryContainerWrapper = styled("div")({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
});
export const SummaryInfoContainer = styled("div")({
    display: "flex",
    flexDirection: "column",
});
export const GridContainer = styled("div")({
    width: "100%",
    flex: 1,
});
export const SummaryHeader = styled.div `
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 16px;
`;
export const SummaryContent = styled.div `
    font-size: ${fontSizes.MEDIUM};
    margin-bottom: 16px;
`;
export const ActionButton = styled(HXMenuButton).attrs({ secondary: true, startIcon: null, label: "" }) `
    border-color: ${colors.black_12};
    color: ${colors.black_lighter};
    padding: 8px;
    min-width: 0;

    &:hover {
        border-color: ${colors.black_lighter};
    }

    & .MuiButton-endIcon {
        margin: 0;
    }
`;
export const RemoveIcon = styled(Delete) `
    li:not(.Mui-disabled) && {
        color: ${colors.tulip_main};
    }
`;
export const ClassificationParent = styled(HXMobilePageWithFixedHeaderAndFooterContainer).attrs({
    overflowYHidden: false,
}) ``;
export const ClassificationContent = styled(HXMobilePageWithFixedHeaderAndFooterContent).attrs({
    isHeaderAndFooterFixed: true,
}) `
    flex: 1 0 0;
    padding: 24px;
`;
export const ClassificationFooterContainer = styled(FlexRowDiv) `
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-top: 1px solid ${colors.black_12};
`;
export const ClassificationFooterActions = styled(FlexRow) `
    flex: 1;
    gap: 16px;
    justify-content: flex-end;
`;
export const OverrideTagForm = styled(FlexColumnDiv) `
    gap: 16px;
    margin-top: 16px;
    font-size: ${fontSizes.STANDARD};

    & ${HXTextField} {
        width: ${(props) => { var _a; return (_a = props.textFieldWidth) !== null && _a !== void 0 ? _a : "360px"; }};
    }

    & button {
        align-self: flex-start;
    }
`;
export const TagChip = styled.span `
    background-color: ${(props) => (props.verified ? "#e8f5e9" : "#e3f2fd")};
    color: ${(props) => (props.verified ? "#2e7d32" : "#1976d2")};
    padding: 4px 8px;
    border-radius: 16px;
    font-size: 0.875rem;
    border: 1px solid ${(props) => (props.verified ? "#81c784" : "#90caf9")};
    display: inline-flex;
    align-items: center;
    gap: 4px;
`;
export const StyledLink = styled(Typography) `
    cursor: pointer;
    color: ${colors.accents_sky};
    text-decoration: underline;
`;
export const ClassificationCard = styled(Card) `
    flex: 1;
    width: 50%;
    min-width: 400px;
    border: ${(props) => (props.active ? `1px solid ${colors.forest_main}` : "none")};
`;
export const CardHeader = styled.div `
    padding: 16px;
    border-bottom: 1px solid ${colors.black_12};
    display: flex;
    align-items: center;
    gap: 12px;
    background-color: ${(props) => (props.active ? colors.forest_30 : colors.sunset_8)};
`;
export const CardHeaderContent = styled(FlexRow) `
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;
export const StatusBadge = styled.div `
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 13px;
    font-weight: 600;
    background-color: ${(props) => (props.inProgress ? colors.sunset_light : props.active ? colors.forest_light : colors.sunset_light)};
    color: ${(props) => (props.inProgress ? colors.black_main : props.active ? colors.forest_dark : colors.black_main)};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
`;
export const MetricsSection = styled(FlexColumn) `
    justify-content: center;
    align-items: center;
    min-height: 184px;
    gap: 24px;
    padding: 0 24px;
`;
export const MetricsContent = styled(FlexRow) `
    justify-content: ${(props) => { var _a; return (_a = props.justifyContent) !== null && _a !== void 0 ? _a : "space-between"; }};
    align-items: center;
    flex-wrap: wrap;
`;
export const PercentageIndicator = styled.span `
    font-size: ${fontSizes.SMALL};
    margin-left: 4px;
`;
export const MetricItem = styled(FlexColumn) `
    text-align: left;
    min-width: 180px;
    strong {
        display: block;
        font-size: 24px;
        color: ${colors.black_main};
    }
`;
export const CardActions = styled.div `
    padding: 16px;
    border-top: 1px solid ${colors.black_12};
    display: flex;
    justify-content: flex-end;
    gap: 8px;
`;
export const ColumnWrapper = styled.div `
    width: 100%;
`;
export const ColumnContent = styled.div `
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
